import React from "react";
import { IStorePurchaseLinkConfig } from "models/IAppConfig";
import SelectionButton from "./SelectionButton";
import clsx from "clsx";
import Collapse from "@material-ui/core/Collapse";
import PurchaseSubscriptionInput from "./PurchaseSubscriptionInput";

interface IProps {
    stores: IStorePurchaseLinkConfig[];
    platformCode?: string;
    currentlySelectedStore?: IStorePurchaseLinkConfig;
    onSubscriptionStoreTabClick: (store: IStorePurchaseLinkConfig) => void;
}

export default function StoreSelect(props: IProps) {
    const { stores, platformCode, onSubscriptionStoreTabClick, currentlySelectedStore } = props;

    if (stores.length === 0) {
        console.log(`no stores provided`);
        return <div></div>;
    }

    const buttons = stores.map((store) => {
        if (typeof store.storeCode === "undefined") {
            console.log("Store storeCode is undefined");
            return null;
        }
        if (typeof store.displayName === "undefined") {
            console.log("Store displayName is undefined");
            return null;
        }

        if (typeof store.subscription !== "undefined") {
            return (
                <div style={{ margin: 5 }}>
                    <SelectionButton
                        gtmSelector={clsx(
                            `${store.storeCode}_Store_Selection`,
                            `${platformCode}_Platform`
                        )}
                        key={store.storeCode}
                        onClick={() => onSubscriptionStoreTabClick(store)}
                    >
                        {store.displayName}
                    </SelectionButton>
                </div>
            );
        }

        const isDisabled = typeof store.link === "undefined" || store.link.length === 0;

        return (
            <div style={{ margin: 5 }}>
                <SelectionButton
                    href={store.link}
                    gtmSelector={clsx(
                        `${store.storeCode}_Store_Selection`,
                        `${platformCode}_Platform`
                    )}
                    key={store.storeCode}
                    disabled={isDisabled}
                >
                    {store.displayName}
                </SelectionButton>
            </div>
        );
    });

    const showEmailCapture = typeof currentlySelectedStore !== "undefined";

    return (
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            <Collapse in={!showEmailCapture}>
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    {buttons}
                </div>
            </Collapse>
            <Collapse in={showEmailCapture}>
                <PurchaseSubscriptionInput
                    subscriptionConfig={currentlySelectedStore?.subscription}
                />
            </Collapse>
        </div>
    );
}
